import React, { useContext, useState } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { StateModel } from 'redux/reducers';
import { IApplication } from 'typings/application/applications';
import { onboardingAPI } from 'api/onboarding/onboardingAPI';
import { ApplicationStatuses } from 'enums/onboarding/crm';
import { VerificationContext } from 'modules/Onboarding/Contexts/VerificationContext';
import { updateActiveApplication } from 'redux/actions/applications';
import { useDispatch, useSelector } from 'react-redux';
import { CHANGE_VIEW_TYPES, changeView } from 'redux/actions/view';

// components
import { Button, Modal, Tooltip } from '@ui';

const SubmitForReviewButton = () => {
  const dispatch = useDispatch();
  const verificationContext = useContext(VerificationContext);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const activeApplication = useSelector<StateModel, IApplication | null>(
    (state) => state.applications.activeApplication,
  );

  const onSubmit = async () => {
    setIsLoading(true);
    await dispatch(
      changeView(async () => {
        await onboardingAPI.submitApplicationForReview();
        await dispatch(updateActiveApplication());
        Modal.info({
          icon: '',
          closable: true,
          title: t('application_documentation.success_submit_title', {
            ns: 'onboarding',
          }),
          content: t('application_documentation.success_submit_description', {
            ns: 'onboarding',
          }),
          okText: t('ok', { ns: 'common' }),
          width: 700,
        });
      }, CHANGE_VIEW_TYPES.ONBOARDING_VERIFICATION_PAGE),
    );
    setIsLoading(false);
  };

  return activeApplication?.activeScopeStatus !==
    ApplicationStatuses.InReview ? (
    <StyledTooltip
      placement="top"
      title={
        !verificationContext?.canSubmitForReview
          ? t('application_documentation.disabled_submit_action_tooltip_text', {
              ns: 'onboarding',
            })
          : null
      }
    >
      <StyledButton
        onClick={onSubmit}
        loading={isLoading}
        disabled={!verificationContext?.canSubmitForReview || isLoading}
      >
        {t('submit_for_review')}
      </StyledButton>
    </StyledTooltip>
  ) : null;
};

const StyledButton = styled(Button)`
  width: 100%;
`;

const StyledTooltip = styled(Tooltip)`
  width: 100%;
`;

export default SubmitForReviewButton;
